// Composant icône catégorie : essaye d'abord l'image 3D pro,
// fallback sur l'emoji si l'image n'est pas dispo (réseau, nouvelle catégorie, etc.)
import React, { useState } from "react";

export const CategoryIcon = ({ catKey, emoji, size = 48, className = "" }) => {
  const [errored, setErrored] = useState(false);

  if (errored || !catKey) {
    return (
      <span style={{ fontSize: size, lineHeight: 1 }} className={className} aria-hidden>
        {emoji}
      </span>
    );
  }

  return (
    <img
      src={`/category_icons/${catKey}.png`}
      alt=""
      width={size}
      height={size}
      onError={() => setErrored(true)}
      style={{ width: size, height: size, objectFit: "contain" }}
      className={className}
      loading="lazy"
      data-testid={`cat-icon-${catKey}`}
    />
  );
};
